import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { Typography } from '@comparethemarketau/manor-typography';

import { ProviderLogo } from '../common/provider_logo';
import { ComparePill } from '../common/compare_pill';
import { withQuoteFlatten } from '../common/with_quote_flatten';
import { ProductUnderwritten } from '../common/product_underwritten';

const useStyles = createUseStyles((theme) => ({
    container: {
        marginBottom: '0.5rem'
    },
    topContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'start',
        columnGap: '2rem',
        alignItems: 'center',
        marginBottom: '1.2rem'
    },
    logo: {
    },
    productName: {
        fontSize: theme.fontSize.lg,
        lineHeight: theme.lineHeight.tight,
        fontWeight: theme.fontWeight.semibold,
        color: theme.colors.primary800
    },
    productUnderwritten: {
        fontSize: theme.fontSize.xs,
        lineHeight: theme.lineHeight.normal,
        fontWeight: theme.fontWeight.normal,
        color: theme.colors.grey700
    }
}));

// eslint-disable-next-line valid-jsdoc
/**
 * Layout:
 * Provier-logo       Compare-pill
 * Product-name
 * Povider-underwritten
 */
const _ProductSummaryXs = (props) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });
    const { className, providerCode, productName, productUnderwriterName, productId } = props;

    return (
        <div className={classNames('test-policyProductCard-summary-xs', className, classes.container)}>
            <div className={classes.topContainer}>
                <ProviderLogo className={classes.logo} code={providerCode} />
                <Typography className={classes.productName}>{productName}</Typography>
            </div>
            <ProductUnderwritten className={classes.productUnderwritten} productUnderwriterName={productUnderwriterName} />
        </div>
    );
};

_ProductSummaryXs.propTypes = {
    className: PropTypes.string,
    quote: PropTypes.object,
    productName: PropTypes.string,
    productUnderwriterName: PropTypes.string,
    providerCode: PropTypes.string.isRequired,
    productId: PropTypes.string.isRequired
};

const ProductSummaryXs = withQuoteFlatten(_ProductSummaryXs);

export { ProductSummaryXs };
